<template>
    <v-content>
        <v-container fluid fill-height>
            <v-row justify="center">
                <v-col cols="12" sm="7" md="4" lg="3">
                    <v-alert
                        v-model="alert.show"
                        dismissible
                        :color="alert.color"
                        :icon="alert.icon"
                        :type="alert.type"
                        transition="scale-transition"
                        class="mb-3"
                    >{{ alert.text }}</v-alert>
                    <div class="login_content">
                        <v-img
                            class="login_image"
                            :src="require('@/assets/logo.svg')"
                            alt="Tasklaw - Software Jurídico"
                            aspect-ratio="2"
                            max-height="143px"
                            contain
                        ></v-img>
                        <v-spacer></v-spacer>
                        <form-new-password v-if="showFormNewPassword" :loading="loading" @change-form="changeForm" @newPassword="requestNewPassword"></form-new-password>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
import API from '@/api'
import FormNewPassword from '@/components/Login/FormNewPassword.vue'

export default {
    name: 'login-layout',
    components: {
        FormNewPassword
    },
    data: () => ({
        loading: false,
        showFormNewPassword: true,
        alert: {
            show: false,
            color: undefined,
            icon: undefined,
            type: undefined,
            text: undefined
        }
    }),
    methods: {
        showLoading () {
            return !this.loading
        },
        changeForm (boolean) {
            this.showFormNewPassword = boolean
        },
        requestNewPassword (params) {
            this.showLoading()
            let endpoint = API.EndPoints.newPassword
            new API(endpoint, params).request().then(async response => {
                this.$helpers.setItemLocalStorage('sessionToken', response.body.result.sessionToken)

                endpoint = API.EndPoints.me
                const profile = await new API(endpoint, {}).request().then(async response => {
                    return response.body
                }, error => {
                    if (error.status !== 0) this.dispatchAlertError(error.body.error)
                })

                const companies = await this.$helpers.getAllUserCompanies(profile)

                this.$helpers.setLocalStorage(profile, companies)
                this.$router.push('/demandas').catch(e => {})
            }, error => {
                if (error.status !== 0) this.dispatchAlertError(error.body.error)
            })
        },
        dispatchAlert (color, icon, type, text) {
            this.alert.show = true
            this.alert.color = color
            this.alert.icon = icon
            this.alert.type = type
            this.alert.text = text
        },
        dispatchAlertError (error) {
            this.dispatchAlert('red', 'warning', 'warning', error)
            this.showLoading()
        }
    }
}
</script>

<style lang="stylus" scoped>
    .login_content
        border-radius: 4px
        background-color: #ffffff

    .login_image
        border: 1px solid rgba(0, 0, 0, 0.12)
        border-bottom: none
</style>
